import QuantityInput from './QuantityInput.vue';

export default QuantityInput;
